import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import NCCNOptions from './pages/NCCNOptions';
import ClinicalTrials from './pages/ClinicalTrials';
import OffGuidelineDrugs from './pages/OffGuidelineDrugs';
import WholeHealth from './pages/WholeHealth';
import Innovation from './pages/Innovation';
import EndOfLifeCare from './pages/EndOfLifeCare';
import ScrollToTop from './components/ScrollToTop';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/nccn-options" element={<NCCNOptions data-id="element-7" />} data-id="element-6" />
          <Route path="/clinical-trials" element={<ClinicalTrials data-id="element-9" />} data-id="element-8" />
          <Route path="/off-guideline-drugs" element={<OffGuidelineDrugs data-id="element-11" />} data-id="element-10" />
          <Route path="/whole-health" element={<WholeHealth data-id="element-13" />} data-id="element-12" />
          <Route path="/innovation" element={<Innovation data-id="element-15" />} data-id="element-14" />
          <Route path="/end-of-life-care" element={<EndOfLifeCare data-id="element-17" />} data-id="element-16" />
        </Routes>
      </Layout>
    </Router>;
}